const RELOAD_FLAG_KEY = 'chunk-load-reload-attempted';

const CHUNK_ERROR_PATTERN =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading chunk .* failed/i;

export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;
  const message = error instanceof Error ? error.message : String(error);
  return CHUNK_ERROR_PATTERN.test(message);
}

/**
 * Reloads the page once per session to recover from a stale chunk (e.g. after
 * a deploy/restart replaced the built assets while this tab was still open).
 * Returns false if a reload was already attempted this session, so callers
 * can fall back to a real error UI instead of reloading forever.
 */
export function reloadOnceForChunkError(): boolean {
  if (sessionStorage.getItem(RELOAD_FLAG_KEY)) {
    return false;
  }
  sessionStorage.setItem(RELOAD_FLAG_KEY, '1');
  window.location.reload();
  return true;
}

/**
 * Call once the app has mounted successfully. Clears the reload guard a few
 * seconds later so a *future* stale-chunk incident (e.g. a later deploy) can
 * still trigger one auto-reload instead of being permanently suppressed by
 * an earlier incident in the same tab session.
 */
export function armChunkErrorRecovery(): void {
  window.setTimeout(() => sessionStorage.removeItem(RELOAD_FLAG_KEY), 5000);
}
